import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const SelectionBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  & > * {
    margin-bottom: 1.563rem;
  }

  ${mediaQuery('md')} {
    flex-direction: row;
    margin-bottom: 1.563rem;

    & > * {
      margin-bottom: 1.563rem;
    }

    & > *:not(:last-child) {
      margin-right: 2.5rem;
    }
  }
`;
